import React, { useState } from 'react'
import { IoChevronDownOutline } from 'react-icons/io5';
import MegaMenus from './MegaMenus/MegaMenus';
import DefaultMenus from './MegaMenus/DefaultMenus';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { PiMinus, PiPlus, PiPlusLight } from 'react-icons/pi';
import { isMobile } from '../service';

const Navitem = ({ item ,onClick}) => {
  const [open, setOpen] = useState(false);
  let timeoutId;

  const handleMouseEnter = () => {
    if (!isMobile()) {
      clearTimeout(timeoutId);
      setOpen(true);
    }

  };

  const handleMouseLeave = () => {
    if (!isMobile()) {
      timeoutId = setTimeout(() => setOpen(false), 200);

    }
    // Delay 200ms trước khi ẩn menu
  };
  const handleClick = () => {
    if (isMobile()) {
      setOpen((prev) => !prev);
    }
  };
  return (
    <div

      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
  
    >

      <Link  to={item.href ?? "/"} className={`border-b  lg:border-none xl:border-none py-2  xl:py-2 xl:px-4 flex flex-col justify-center-center gap-1 group ${(item?.isMega && item?.childrens) ? "relative" : ""}`} >
        <div className='flex justify-between items-center w-full gap-2'>
          <div className='flex gap-2 items-center  '>
            <span className='lg:text-white font-bold text-sm xl:text-base group-hover:text-[--color-button-2] transition-all duration-150' >
              {item.label}
            </span>


            {item.badge && <span
              className={`text-[10px] px-1 py-0.5 rounded ${item.badge === "HOT"
                ? "bg-pink-200 text-pink-700"
                : "bg-green-200 text-green-700"
                }`}
            >
              {item.badge}
            </span>}
          </div>
          {item?.isMega && <button className='lg:text-white font-bold text-base'>
            <IoChevronDownOutline className='hidden lg:block' />
           {open &&  <PiMinus className='block lg:hidden'     onClick={handleClick}/>}
           {!open &&  <PiPlus className='block lg:hidden'     onClick={handleClick}/>}

          </button>}
        </div>


        {!item.ishome && <>
          {item?.isMega && !item?.childrens && <MegaMenus item={item} open={open} onClick={onClick} />}
          {(item?.isMega && item?.childrens) && <DefaultMenus items={item?.childrens || []} open={open} onClick={onClick} />}

        </>}

      </Link>
    </div>
  )
}
export default Navitem;
